<template>
  <div>
    <p></p>
  </div>
</template>

<script>
export default {
  name: 'bottom'
}
</script>

<style scoped>
p{
  height: 0px;
  line-height: 0px;
  text-align: left;
  font-size: 12px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/system/index/layout/Footer/bottom.vue